import React, {PureComponent} from 'react';
import {
    DispensingOrdersFuelsStock,
    DispensingOrdersViewState,
    Car,
    Carrier,
    IDispensingOrderFuel,
    IDispensingOrdersFormProps,
    IDispensingOrdersFormState,
    Driver
} from "./models";
import {DispensingOrdersService} from "./DispensingOrders.service";
import {AuthenticationContext} from "../../services/context/authentication.context";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import Select, {OptionsType} from "react-select";
import {IOptions} from "../../common/reactSelectModels";
import DatePicker from 'react-date-picker'
import {dateFormatOptions} from "../../common/dateFormatterConfig";
import Button from "react-bootstrap/Button";
import {DispensingOrdersConfirmationModal} from "./DispensingOrdersConfirmationModal";

export class DispensingOrdersForm extends PureComponent<IDispensingOrdersFormProps, IDispensingOrdersFormState> {

    static contextType = AuthenticationContext;

    constructor(props: any) {
        super(props);
        this.state = {
            customerId: null,
            isSubmittingModalOpen: false,
            dispensingOrderFuels: [],
            carriers: [],
            cars: [],
            drivers: [],
            loading: true,
            form: {
                documentNumber: '',
                owner: 'TT',
                ownerLabel: 'Tartu Terminal',
                carrier: '',
                carrierLabel: '',
                car: '',
                carLabel: '',
                driver: '',
                driverLabel: '',
                validUntil: '',
                validUntilDate: undefined,
            },
            validated: false
        };
    }

    getDispensingOrderFuels = () => {
        if (this.state.customerId === null)
            return;

        this.setState({loading: true});
        DispensingOrdersService.getDispensingOrderFuels(this.state.customerId).then((response: Array<IDispensingOrderFuel>) => {
            this.setState({
                loading: false,
                validated: false,
                dispensingOrderFuels: response.map(fuel => ({
                    ...fuel,
                    batchAmount: '',
                    dosBatchAmount: '',
                    isSelected: false,
                    isDosVisible: fuel.remoteDosBatchId !== null
                }))
            }, () => {
                this.prefillFields();
            });
            this.getCars();
            this.getDrivers();
            this.getCarriers();
        }).catch(error => {
            this.setState({loading: false});
            return console.error(error);
        });
    };

    getCarriers = () => {
        DispensingOrdersService.getCarriers().then((response: Array<Carrier>) => {
            this.setState({
                carriers: !response ? [] : response.sort((a, b) => a.name.localeCompare(b.name))
            }, () => {
                this.prefillFields();
            });
        });
    };

    getCars = () => {
        if (this.state.customerId === null)
            return;

        DispensingOrdersService.getCars(this.state.customerId).then((response: Array<Car>) => {
            this.setState({
                cars: response
            }, () => {
                this.prefillFields();
            });
        });
    };

    getDrivers = () => {
        if (this.state.customerId === null)
            return;

        DispensingOrdersService.getDrivers(this.state.customerId).then((response: Array<Driver>) => {
            this.setState({
                drivers: !response ? [] : response.sort((a, b) => (a.name < b.name) ? -1 : ((a.name > b.name) ? 1 : 0))
            }, () => {
                this.prefillFields();
            });
        });
    };

    updateCustomerId = () => {
        if (this.context.state.customerId !== this.state.customerId) {
            this.setState({
                ...this.state,
                customerId: this.context.state.customerId,
            }, () => {
                this.getDispensingOrderFuels();
            });
        }
    };

    prefillFields = () => {
        const order = this.props.editingDispensingOrder;
        if (!order)
            return;
        const warehouseChecked = false;
        const fuels = [...this.state.dispensingOrderFuels];
        for (const savedFuel of order.productRows) {
            const fuelRow = fuels.find(fuelRow =>
                (fuelRow.remoteDosBatchId === savedFuel.remoteBatchId.toString()) || (fuelRow.remoteBatchId === savedFuel.remoteBatchId.toString()));
            if (!fuelRow) {
                continue;
            }

            if (!warehouseChecked) {
                if (fuelRow.remoteStockId === "33")
                    this.props.onFuelStockChange(DispensingOrdersFuelsStock.EXCISE);
                else if (fuelRow.remoteStockId === "1")
                    this.props.onFuelStockChange(DispensingOrdersFuelsStock.COMMERCIAL);
            }


            fuelRow.isSelected = true;

            if (fuelRow.remoteBatchId === savedFuel.remoteBatchId.toString()) {
                fuelRow.batchAmount = savedFuel.quantity;
            } else if (fuelRow.remoteDosBatchId === savedFuel.remoteBatchId.toString()) {
                fuelRow.dosBatchAmount = savedFuel.quantity;
            }

        }
        const carrier = this.state.carriers.find(carrier => carrier.searchCode === order.transporterCode);
        const car = this.state.cars.find(car => car.code === order.carCode);
        this.setState({
            form: {
                documentNumber: order.authorizationNumber,
                owner: this.state.form.owner,
                ownerLabel: this.state.form.ownerLabel,
                carrier: carrier ? carrier.searchCode : '',
                carrierLabel: order.productOwnerName,
                car: car ? car.code : '',
                carLabel: car ? car.name : '',
                driver: order.driverCode,
                driverLabel: order.driverName,
                validUntil: new Intl.DateTimeFormat('et', dateFormatOptions).format(new Date(order.validUntil)),
                validUntilDate: new Date(order.validUntil)
            },
            dispensingOrderFuels: fuels
        });
    };

    componentDidMount(): void {
        this.updateCustomerId();
        if (this.props.viewState === DispensingOrdersViewState.EDIT) {
            this.prefillFields()
        }
    }

    componentDidUpdate(prevProps: Readonly<IDispensingOrdersFormProps>, prevState: Readonly<IDispensingOrdersFormState>, snapshot?: any): void {
        if (prevProps.fuelStock !== this.props.fuelStock) {
            for (const dispensingOrderFuel of this.state.dispensingOrderFuels) {
                dispensingOrderFuel.isSelected = false;
                dispensingOrderFuel.batchAmount = '';
                dispensingOrderFuel.dosBatchAmount = '';
            }
        }
        this.updateCustomerId();
    }

    validateFields = () => {
        let invalid = false;

        if (
            this.state.form.documentNumber === '' ||
            this.state.form.owner === '' ||
            this.state.form.carrier === '' ||
            this.state.form.car === '' ||
            this.state.form.driver === '' ||
            this.state.form.validUntilDate === undefined) {
            invalid = true;
        }

        return !invalid;
    };

    validateFuels = () => {
        let invalid = false;

        const selectedFuels = this.state.dispensingOrderFuels.filter(fuel => fuel.isSelected);
        const anyInvalidFuel = selectedFuels.findIndex(fuel =>
            (fuel.batchAmount === '' && fuel.dosBatchAmount === '') ||
            (
                ( fuel.batchAmount < 0 || (fuel.batchAmount === ''
                    && (!fuel.isDosVisible || (fuel.isDosVisible && fuel.dosBatchAmount === ''))))
            ) ||
            (fuel.dosBatchAmount < 0 || (fuel.dosBatchAmount === '' && fuel.batchAmount === ''))

            );
        if (anyInvalidFuel !== -1) {
            invalid = true;
        }

        return !invalid;
    };

    validateFormSubmit = (e: any) => {
        const form = e.currentTarget;
        e.preventDefault();
        e.stopPropagation();

        this.setState({validated:true});

        const fields = this.validateFields();
        const fuels = this.validateFuels();

        if (!fields) {
            const startOfFields = document.getElementById("form-document-number");
            if (startOfFields) startOfFields.scrollIntoView({behavior: "smooth", inline: 'start'});
        } else if (!fuels) {
            const fuelsTable = document.getElementById("dispensing-order-fuels");
            if (fuelsTable) fuelsTable.scrollIntoView({behavior: "smooth", inline: 'start'});
        }
        const formValid = form.checkValidity() && fields && fuels;

        if (formValid) {
            this.toggleModal(false);
            this.setState({validated: false});
        }
    };

    toggleFuelSelect = (remoteProductId: number, isSelected: boolean) => {
        const target: IDispensingOrderFuel | undefined = this.state.dispensingOrderFuels.find(val => val.remoteProductId === remoteProductId);
        if (!target)
            return;
        if (isSelected) {
            target.isSelected = false;
            target.batchAmount = '';
            target.dosBatchAmount = '';
        } else {
            target.isSelected = true;
        }
        this.setState({
            ...this.state,
            dispensingOrderFuels: [...this.state.dispensingOrderFuels]
        }, () => {
        });

    };
    toggleModal = (triggerRefresh: boolean) => {
        this.setState({
            isSubmittingModalOpen: !this.state.isSubmittingModalOpen
        }, () => {
            if (triggerRefresh) {
                this.props.onSubmitReload();
            }
        });
    };
    onBatchAmountChange = (amount: any, remoteProductId: number, isDos: boolean) => {
        const target = this.state.dispensingOrderFuels.find(val => val.remoteProductId === remoteProductId);
        if (target) {
            if (isDos) {
                target.dosBatchAmount = amount;
            } else {
                target.batchAmount = amount;
            }
            this.setState({
                ...this.state,
                dispensingOrderFuels: [...this.state.dispensingOrderFuels]
            });
        }
    };

    getOwnerOptions: () => OptionsType<IOptions> = () => {
        const options: any = [];
        if (this.context.state.customer) {
            switch (this.context.state.customer.searchCode) {
                case 'ALEXELA':
                    options.push({
                        label: 'Alexela AS',
                        value: 'ALEXELA'
                    });
                    break;
                case 'OLE':
                    options.push({
                        label: 'Olerex AS',
                        value: 'OLE'
                    });
                    break;
                case 'ORL':
                    options.push({
                        label: 'ORLEN Eesti OÜ',
                        value: 'ORL'
                    });
                    break;
                case 'TTT':
                default:
                    options.push({
                        label: 'Tartu Terminal',
                        value: 'TT'
                    });
            }
        }

        return options;
    };
    getOwner: (value: string) => 'ALEXELA' | 'OLE' | 'ORL' | 'TT' = (value: string) => {
        switch (value) {
            case 'ALEXELA':
                return 'ALEXELA';
            case 'OLE':
                return 'OLE';
            case 'ORL':
                return 'ORL';
            case 'TTT':
            default:
                return 'TT';
        }
    };
    getRowBatchAmount = (remoteProductId: number) =>
        this.state.dispensingOrderFuels.find(val => val.remoteProductId === remoteProductId)?.batchAmount;
    getRowDosBatchAmount = (remoteProductId: number) =>
        this.state.dispensingOrderFuels.find(val => val.remoteProductId === remoteProductId)?.dosBatchAmount;

    render() {
        const ownerOptions: OptionsType<IOptions> = this.getOwnerOptions();
        const carriersOptions: OptionsType<IOptions> =
            this.state.carriers.map((carrier: Carrier) => ({value: carrier.searchCode, label: carrier.name}));
        const carsOptions: OptionsType<IOptions> =
            this.state.cars.filter(car => car.code).map((car: Car) => ({value: car.code, label: car.name }));
        const driversOptions: OptionsType<IOptions> =
            this.state.drivers.map((driver: Driver) =>
                ({value: driver.code, label: `${driver.name} - ${driver.personalCode ? driver.personalCode : 'Isikukoodi info puudub'}`}));

        let fuelStockId = "";
        if (this.props.fuelStock === DispensingOrdersFuelsStock.EXCISE)
            fuelStockId = "33";
        else if (this.props.fuelStock === DispensingOrdersFuelsStock.COMMERCIAL)
            fuelStockId = "1";

        const fuelRows = this.state.dispensingOrderFuels
            .filter(fuel => fuel.remoteStockId === fuelStockId)
            .map((fuel: IDispensingOrderFuel) => {
                return (
                    <tr key={fuel.remoteProductId} className={fuel.isSelected ? 'row--selected' : ''}>
                        <td>
                            {
                                !fuel.isSelected &&
                                <div className="py-2 fuel-row__remove" key={fuel.remoteProductId + '_unselected'}>
                                <span className="icon--16 mx-auto icon__plus"
                                      onClick={() => this.toggleFuelSelect(fuel.remoteProductId, fuel.isSelected)}/>
                                </div>

                            }
                            {
                                fuel.isSelected &&
                                <div className="py-2 fuel-row__remove" key={fuel.remoteProductId + '_selected'}>
                                <span className="icon--16 mx-auto icon__minus"
                                      onClick={() => this.toggleFuelSelect(fuel.remoteProductId, fuel.isSelected)}/>
                                </div>
                            }
                        </td>
                        <td>
                            <h5 className={'my-auto ' + (fuel.isSelected ? 'text-primary' : 'text-black-50')}>
                                {fuel.productName}
                            </h5>
                        </td>
                        <td>
                            <p className='3 my-auto '>
                                {fuel.quantity} L
                            </p>
                        </td>
                        <td>
                            <div className={"d-flex flex-column my-auto"}>
                                <Form.Group controlId={'fuel' + fuel.remoteProductId} className={'mb-0 d-flex'}>
                                    <Form.Label className={'mb-0 align-self-center mr-2 d-none d-md-block'}>
                                        <span className='text-nowrap'>Kogus</span>
                                    </Form.Label>
                                    <Form.Control required min={0} step={100}
                                                  disabled={!fuel.isSelected}
                                                  isInvalid={fuel.isSelected && this.state.validated && (fuel.batchAmount < 0 || (fuel.batchAmount === ''
                                                      && (!fuel.isDosVisible || (fuel.isDosVisible && fuel.dosBatchAmount === ''))))}
                                                  value={this.getRowBatchAmount(fuel.remoteProductId)}
                                                  onChange={(e) => this.onBatchAmountChange(e.target.value, fuel.remoteProductId, false)}
                                                  type="number"/>
                                </Form.Group>
                                {
                                    fuel.isDosVisible &&
                                    <Form.Group controlId={'fuel' + fuel.remoteDosBatchId} className={'mb-0 mt-2 d-flex'}>
                                        <Form.Label className={'mb-0 align-self-center mr-2 d-none d-md-block'}>
                                            <span className='text-nowrap'>DOS kogus</span>
                                        </Form.Label>
                                        <Form.Control required
                                                      disabled={!fuel.isSelected}
                                                      isInvalid={fuel.isSelected && this.state.validated &&
                                                      fuel.isDosVisible && (fuel.dosBatchAmount < 0 || (fuel.dosBatchAmount === '' && fuel.batchAmount === ''))}
                                                      min={0} step={100}
                                                      value={this.getRowDosBatchAmount(fuel.remoteProductId)}
                                                      onChange={(e) => this.onBatchAmountChange(e.target.value, fuel.remoteProductId, true)}
                                                      type="number"/>
                                    </Form.Group>
                                }
                            </div>
                        </td>
                    </tr>)
            });

        return (
            <>
                {
                    this.state.loading &&
                        <div className="text-center"><Spinner animation={"grow"}/></div>
                }
                {
                    !this.state.loading &&
                    <>
                        {
                            fuelRows.length > 0 &&
                            <table id={'dispensing-order-fuels'} className="dispensing-order-fuels__table table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th></th>
                                    <th>Nimetus</th>
                                    <th>Laoseis</th>
                                    <th>Valitud kogus</th>
                                </tr>
                                </thead>
                                <tbody>
                                    {fuelRows}
                                </tbody>
                            </table>
                        }
                        {
                            fuelRows.length === 0 &&
                            <div className="text-center">Kirjeid ei leitud</div>
                        }
                        {
                            this.state.dispensingOrderFuels
                                .filter(fuel => fuel.remoteStockId === fuelStockId).find(fuel => fuel.isSelected) &&
                            <Form noValidate validated={this.state.validated} className={'mt-4 col-12 col-lg-8 align-self-center'}
                                  onSubmit={this.validateFormSubmit}>
                                <Form.Group controlId={'form-document-number'} className={'mb-0 mt-2 d-flex row'}>
                                    <Form.Label className={'mb-0 align-self-center col-3 text-start text-md-center px-0 pb-1 px-md-2 pb-md-0'}>
                                        <span className="text-nowrap">Alusdokument</span>
                                    </Form.Label>
                                    <Form.Control required className={'col-12 col-md-9'}
                                                  minLength={1}
                                                  value={this.state.form.documentNumber}
                                                  onChange={(e) => this.setState({
                                                      form: {
                                                          ...this.state.form,
                                                          documentNumber: e.target.value
                                                      }
                                                  })}
                                                  type="text"/>
                                    <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId={'form-owner'} className={'mb-0 mt-2 d-flex row'} >
                                    <Form.Label className={'mb-0 align-self-center col-3 text-start text-md-center px-0 pb-1 px-md-2 pb-md-0'}>
                                        <span className='text-nowrap'>Kauba omanik</span>
                                    </Form.Label>
                                    <Select
                                        value={ownerOptions.find(owner => owner.value === this.state.form.owner)}
                                        options={ownerOptions}
                                        className={'col-12 col-md-9 px-0 select-terminal '
                                        + (this.state.form.owner === '' && this.state.validated ? 'invalid' : '')}
                                        placeholder='Vali omanik…'
                                        classNamePrefix={'select'}
                                        isClearable={false}
                                        autosize={true}
                                        container={'body'}
                                        noOptionsMessage={() => "Vasted puuduvad"}
                                        onChange={(option) =>
                                            this.setState({
                                                form: {
                                                    ...this.state.form,
                                                    owner: option ? this.getOwner((option as IOptions).value as string) : 'TT',
                                                    ownerLabel: option ? this.getOwner((option as IOptions).label) : 'Tartu Terminal',
                                                }
                                            })}
                                    />
                                    {
                                        this.state.form.owner === '' && this.state.validated &&
                                        <div className="d-block text-right invalid-feedback">Kohustuslik väli</div>
                                    }
                                </Form.Group>
                                <Form.Group controlId={'form-carriers'} className={'mb-0 mt-2 d-flex row'}>
                                    <Form.Label className={'mb-0 align-self-center col-3 text-start text-md-center px-0 pb-1 px-md-2 pb-md-0'}>
                                        <span className='text-nowrap'>Vedaja</span>
                                    </Form.Label>
                                    <Select
                                        value={carriersOptions.find(carrier => carrier.value === this.state.form.carrier)}
                                        options={carriersOptions}
                                        className={'col-12 col-md-9 px-0 select-terminal '
                                        + (this.state.form.carrier === '' && this.state.validated ? 'invalid' : '')}
                                        placeholder='Vali vedaja…'
                                        classNamePrefix={'select'}
                                        isClearable={true}
                                        autosize={true}
                                        container={'body'}
                                        noOptionsMessage={() => "Vasted puuduvad"}
                                        onChange={(option) =>
                                            this.setState({
                                                form: {
                                                    ...this.state.form,
                                                    carrier: option ? (option as IOptions).value as string : '',
                                                    carrierLabel: option ? (option as IOptions).label : ''
                                                }
                                            })}
                                    />

                                    {
                                        this.state.form.carrier === '' && this.state.validated &&
                                        <div className="d-block text-right invalid-feedback">Kohustuslik väli</div>
                                    }
                                </Form.Group>
                                <Form.Group controlId={'form-cars'} className={'mb-0 mt-2 d-flex row'}>
                                    <Form.Label className={'mb-0 align-self-center col-3 text-start text-md-center px-0 pb-1 px-md-2 pb-md-0'}>
                                        <span className='text-nowrap'>Auto</span>
                                    </Form.Label>
                                    <Select
                                        value={carsOptions.find(car => car.value === this.state.form.car)}
                                        options={carsOptions}
                                        className={'col-12 col-md-9 px-0 select-terminal '
                                        + (this.state.form.car === '' && this.state.validated ? 'invalid' : '')}
                                        placeholder='Vali auto…'
                                        classNamePrefix={'select'}
                                        isClearable={true}
                                        autosize={true}
                                        noOptionsMessage={() => "Vasted puuduvad"}
                                        container={'body'}
                                        onChange={(option) => {
                                            return this.setState({
                                                form: {
                                                    ...this.state.form,
                                                    car: option ? (option as IOptions).value as string : '',
                                                    carLabel: option ? (option as IOptions).label : ''
                                                }
                                            });
                                        }}
                                    />
                                    {
                                        this.state.form.car === '' && this.state.validated &&
                                        <div className="d-block text-right invalid-feedback">Kohustuslik väli</div>
                                    }
                                </Form.Group>

                                <Form.Group controlId={'form-drivers'} className={'mb-0 mt-2 d-flex row'}>
                                    <Form.Label className={'mb-0 align-self-center col-3 text-start text-md-center px-0 pb-1 px-md-2 pb-md-0'}>
                                        <span className='text-nowrap'>Juht</span>
                                    </Form.Label>
                                    <Select
                                        classNamePrefix={'select'}
                                        value={driversOptions.find(driver => driver.value === this.state.form.driver)}
                                        options={driversOptions}
                                        className={'col-12 col-md-9 px-0 select-terminal ' + (this.state.form.driver === '' && this.state.validated ? 'invalid' : '')}
                                        placeholder='Vali juht…'
                                        isClearable={true}
                                        autosize={true}
                                        container={'body'}
                                        noOptionsMessage={() => "Vasted puuduvad"}
                                        onChange={(option) =>
                                            this.setState({
                                                form: {
                                                    ...this.state.form,
                                                    driver: option ? (option as IOptions).value as string : '',
                                                    driverLabel: option ? (option as IOptions).label : ''
                                                }
                                            })}
                                    />
                                    {
                                        this.state.form.driver === '' && this.state.validated &&
                                        <div className="d-block text-right invalid-feedback">Kohustuslik väli</div>
                                    }
                                </Form.Group>
                                <Form.Group controlId={'form-validUntil'} className={'mb-0 mt-2 d-flex row'}>
                                    <Form.Label className={'mb-0 align-self-center col-3 text-start text-md-center px-0 pb-1 px-md-2 pb-md-0'}>
                                        <span className='text-nowrap'>Kehtib kuni</span>
                                    </Form.Label>
                                    <DatePicker className={'col-12 col-md-9 px-0 ' +
                                    (this.state.form.validUntilDate === undefined && this.state.validated ? 'invalid' : '')}
                                                value={this.state.form.validUntilDate}
                                                locale={'et'}
                                                format={'dd.MM.yyyy'}
                                                onChange={(event: any) => {
                                                    return this.setState({
                                                        form: {
                                                            ...this.state.form,
                                                            validUntil: event ?
                                                                new Intl.DateTimeFormat('et', dateFormatOptions)
                                                                    .format(new Date(event)) : '',
                                                            validUntilDate: event ? new Date(event) : undefined
                                                        }
                                                    });
                                                }}
                                    />
                                    {
                                        this.state.form.validUntilDate === undefined && this.state.validated &&
                                        <div className="d-block text-right invalid-feedback">Kohustuslik väli</div>
                                    }
                                </Form.Group>
                                <div className={'mb-0 mt-4 d-flex row justify-content-end flex-column flex-md-row'}>
                                {/*<div className={'d-flex flex-wrap flex-md-nowrap flex-column flex-md-row'}>*/}
                                    <Button variant="primary" className={''}
                                            type="submit">
                                            <span className="px-5">
                                                Kinnita
                                            </span>
                                    </Button>
                                </div>
                            </Form>
                        }
                    </>
                }

                {
                    this.state.isSubmittingModalOpen &&
                        <DispensingOrdersConfirmationModal
                            isVisible={this.state.isSubmittingModalOpen}
                            formData={this.state.form}
                            customerId={this.state.customerId}
                            viewState={this.props.viewState}
                            editingDispensingOrder={this.props.editingDispensingOrder}
                            warehouse={this.props.fuelStock}
                            selectedFuels={this.state.dispensingOrderFuels.filter(fuel => fuel.isSelected)}
                            handleModalToggle={this.toggleModal}/>
                }
            </>
        );
    }
}

